import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Help from "@material-ui/icons/Help";
import moment from "moment";
import Moment from "react-moment";
import PropTypes from "prop-types";
import { withStyles, makeStyles, useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import LockIcon from '@mui/icons-material/Lock';
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import RadioGroup from '@mui/material/RadioGroup';
import { BreadcrumbPage } from "../../shared";
import { CommonCss } from "../../services/CommonCss";
import { getRequest, putRequest ,postRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import clsx from "clsx";
import Confirmation from "../../shared/alerts/Confirmation";
import { LOADING } from "../../action/index";
import { useSelector, useDispatch } from 'react-redux';
import { getCookie } from "../../services/Cookies";
import { applyMiddleware } from "redux";
import MUIDataTable from "mui-datatables";
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { ThemeProvider } from "@mui/styles";
import userObj from "./UserInstantiation";
import passObj from "./Password";
import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { getDefaultTab } from "../../services/FunctionServices";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CancelIcon from '@mui/icons-material/Cancel';
import FindReplaceIcon from '@mui/icons-material/FindReplace';
import { toast } from "react-toastify";
import searchicon from '../Helpsection_images/searchicon.jpg';
import printicon from '../Helpsection_images/printicon.jpg';
import downloadicon from '../Helpsection_images/downloadicon.jpg';
import viewcolumnicon from '../Helpsection_images/viewcolumnicon.jpg';
import filtericon from '../Helpsection_images/filtericon.jpg';
import Checkimage from '../Helpsection_images/Checkimage.jpg';
import DeleteIcon from '@mui/icons-material/Delete';
import PasswordIcon from '@mui/icons-material/Password';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Radio from '@mui/material/Radio';
import validator from 'validator'
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
  Typography,
} from "@material-ui/core";
import {
  FormGroup,
  FormLabel,
  FormControl,
  ListItemText,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem
} from '@mui/material';
import { passwordObj } from "../account/FormFormat";
import { ContentPasteSearchOutlined } from "@mui/icons-material";
import KeyIcon from '@mui/icons-material/Key';
import KeyOffIcon from '@mui/icons-material/KeyOff';
import IconButton from "@material-ui/core/IconButton";
import { set } from "date-fns";
const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  boxLayout: {
    backgroundColor: "#fff",
    boxShadow: "0px 0px 2px 1px rgb(0 0 0 / 12%)",
    borderRadius: 8,
  },
  tableLayout: {
    border: 0,
    boxShadow: "0 0 0 0 !important",
  },
  txtInput: {
    "& input": {
      padding: "4px 8px",
      fontWeight: 600,
    },
    "& fieldset": {},
  },
  breadcrumbBox: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  btnStyle1: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
  },
  btnStyle3: {
    borderRadius: "12px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "2px 11px",
    alignItems: "right"
  },
  btnStyle4: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  btnStyle5: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ff4717",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
  radioInput: {
    padding: 0,
    "& span.Mui-checked": {
      color: "#ff4717",
    },
  },
  moveinput: {
    marginRight: "100px",
  },
  link: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
      color: "#ff4717"
    }

  },
  link2: {
    textTransform: "capitalize",
    //color: "#ff4717 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    // '&:hover': {
    //   "text-decoration": "underline",
    //   cursor: "pointer",
    //   background: "none",
    //   color: "#ff4717"
    // }

  },
  tableBody: {
    "& .tss-10rusft-MUIDataTableToolbar-icon": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"

    },
    "& .tss-9z1tfs-MUIDataTableToolbar-iconActive": {
      color: "#ff4717",
      boxShadow: "0px -1px 2px 0 #065881 inset, 0px 1px 1px 1px #ccc, 0 0 0 6px #fff, 0 2px 12px 8px #ddd",
      marginLeft: "15px"
    },
    "& .tss-qbo1l6-MUIDataTableToolbar-actions": {
      justifyContent: "left",
      position: "absolute",

    },
    "& .tss-1ufdzki-MUIDataTableSearch-main": {
      marginRight: "10px",
      width: 500
    },
    "& .tss-1fz5efq-MUIDataTableToolbar-left ": {
      position: "absolute",
      right: 25
    }
  },
  link1: {
    textTransform: "capitalize",
    color: "#006400 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    '&:hover': {
      "text-decoration": "underline",
      cursor: "pointer",
      background: "none",
    }

  },
  link3: {
    textTransform: "capitalize",
    color: "#006400 ",
    fontSize: "20px",
    textDecoration: "none",
    background: "none",
    border: "none",
    // marginLeft: "5px",
    "padding-right": "27px",
    // width: "12px",
    // height: "5px",
    // '&:hover': {
    //   "text-decoration": "underline",
    //   cursor: "pointer",
    //   background: "none",
    //}

  },
  text1: {
    fontSize: "20px",
    fontWeight: "400",
    "& b": {
      fontWeight: "500",
    },
  },
  UserIdText: {
    color: "rgb(32 32 32)",
  },
  Box: {
    marginTop: "20px"
  },
  active :{
    color:"Green"
  },
  Inactive:{
    color:'red'
  }
}));


// function Row(props) {
//   const { row, updateUserStatus, editUserDetails, clearFilter, updateBmaccessstatus, getAllUser } = props;
//   const history = useHistory();
//   const [open, setOpen] = React.useState(false);
//   const classes = useStyles();
//   const classesCommonCss = CommonCss();
//   const [openAlert, setOpenAlert] = React.useState(false);
//   const [activeUser, setActiveUser] = React.useState({});
//   const [mode, setMode] = React.useState({});
//   const [BmsccessStatus, setBmaccessstatus] = React.useState({});
//   const [Bunkermasterhistory, setBunkermasterhistory] = useState([]);
//   const dispatch = useDispatch();
//   const handleClickOpen = (row, value) => {
//     //
//     ////console.log(row);
//     if ((row.status == "Registered" || row.status == "Pending") && (getCookie("type") == "VPS Admin")) {
//       setOpenAlert(true);
//       setActiveUser(row);
//     } else {
//       setOpenAlert(true);
//     }
//     setMode(value);
//     setBmaccessstatus({ ...row });
//   };

//   const onAlertSubmit = (status, obj) => {
//     //
//     if (mode === "status") {
//       if (status == "approval") {
//         updateUserStatus({ ...activeUser, status: "Approved" });
//       } else if (status == "reject") {
//         updateUserStatus({ ...activeUser, status: "Denied" });
//       }
//       setOpenAlert(false);
//       setActiveUser({});
//     } else if (mode === "BMaccess") {
//       let BM = "";
//       if (status == "approval") {
//         BM = "Approved";
//       } else if (status == "reject") {
//         BM = "Denied";
//       } else if (status == "cancel") {
//          setOpenAlert(false);
//       }
//       const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
//         `User/UpdateBMAccess/${BmsccessStatus.uId}/${BM}`;
//       getRequest(url)
//         .then((res) => {
//           //
//           if (res) {
//             getAllUser();
//             getallbunkermasterhistory();
//           } else {
//             getAllUser();
//           }

//         }).catch((err) => {
//           //console.log(err);
//         })
//       // setOpenAlert(false);

//     }

//   }
//   const getallbunkermasterhistory = () => {
//     //
//     const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User/BMaccesshistory/${BmsccessStatus.email}`;
//     dispatch({ type: LOADING, payload: true });
//     getRequest(url)
//       .then((res) => {
//         if (res.data) {
//           dispatch({ type: LOADING, payload: false });
//           //console.log(res.data);
//           setBunkermasterhistory(res.data)

//         } else {
//           dispatch({ type: LOADING, payload: false });
//           ToastError(res.data.message);
//         }
//       })
//       .catch((error) => {
//         dispatch({ type: LOADING, payload: false });
//       });
//   }

//   const handleClose = () => {
//     setOpenAlert(false);
//     setActiveUser({});
//   };

//   ;
//   return (
//     <React.Fragment>
//       <TableRow>
//         <TableCell>{row.firstName}</TableCell>

//         <TableCell>{row.lastName}</TableCell>
//         <TableCell>{row.email}</TableCell>
//         <TableCell>{row.isBlackListed === 0 ? <span style={{ color: "#000000", fontWeight: 'bold' }}>No</span> :<span style={{color:"#fb5124",fontWeight: 'bold'}}>Yes</span> }</TableCell>
//         <TableCell>{row.userType}</TableCell>
//         <TableCell>{row.role ? row.role : ""}</TableCell>
//         <TableCell>
//           {row.createddate ? <Moment format="DD/MM/YYYY">{row.createddate}</Moment> : ""}
//         </TableCell>
//         <TableCell>
//           {row.lastLogin ? (<Moment format="DD/MM/YYYY">{row.lastLogin}</Moment>) : ""}
//         </TableCell>
//         <TableCell onClick={() => { handleClickOpen(row, "status") }}>
//           {row.status == 'Registered' || row.status == 'Pending' ? (<span className={clsx(classesCommonCss.pending, classesCommonCss.cursorPointer)}>Pending</span>) : row.status == 'Denied' ? (<span className={clsx(classesCommonCss.inactive, classesCommonCss.cursorPointer)}>Inactive</span>) : (<span className={clsx(classesCommonCss.active, classesCommonCss.cursorPointer)}>{row.status}</span>)}</TableCell>
//         <TableCell className={classesCommonCss.cursorPointer} onClick={() => { editUserDetails(row) }}>{"Edit"}</TableCell>
//         <TableCell className={classesCommonCss.cursorPointer} onClick={() => { handleClickOpen(row, "BMaccess") }}>{row.bmAccess} </TableCell>
//       </TableRow>
//       <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} />
//     </React.Fragment>
//   );
// }

// Row.propTypes = {
//   row: PropTypes.shape({
//     username: PropTypes.string.isRequired,
//   }).isRequired,
// };



export default function AdminPanel() {
  let theme = createTheme();
  theme = responsiveFontSizes(theme)
  const classes = useStyles();
  const history = useHistory();
  const classesCommonCss = CommonCss();
  const dispatch = useDispatch();
  const BreadcrumbList = [{ name: "Admin Panel", url: "" }];
  const [scroll, setScroll] = React.useState('paper');
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [selectedregisteredUsers, setSelectedRegisteredUsers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loadedRegisteredUsers, setLoadedRegisteredUsers] = useState([]);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openStatusAlert, setOpenStatusAlert] = React.useState(false);
  const [statusValue, setStatusValue] = React.useState("Active");
  const [changesParamFilter, setChangesParamFilter] = useState([]);
  const [activeUser, setActiveUser] = React.useState({});
  const [mode, setMode] = React.useState({});
  const [BmsccessStatus, setBmaccessstatus] = React.useState({});
  const [Bunkermasterhistory, setBunkermasterhistory] = useState([]);
  const [Reason, setReason] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [adminPanelchanges, setAdminiPanelChanges] = useState([]);
  const [selectedadminPanelchanges, setSelectedAdminiPanelChanges] = useState([]);
  const [customernameFilter, setCustomernameFilter] = useState([]);
  const [openform, setOpenform] = React.useState(false);
  const [openPassword, setOpenPassword] = React.useState(false);
  const [openLockuser, setOpenLockuser] = React.useState(false);
  const [passwordObj, setPassword] = useState(passObj);
  const [Messaage, setMeassage] = useState("");
  const [uId, setuId] = useState("")
  const [uersId, setUserId] = useState("");
  const [Lock,setLock]=useState('');
  const [Lockstatus,setLockStatus]=useState("");

  const onChangeText = (event) => {
    setPassword({ ...passwordObj, [event.target.name]: event.target.value });
  };
  const handleClickOpenPasswordForm = (username) => {
    setuId(username);
    setOpenPassword(true);

  };
  const lockuseronChangeText = (event) => {
    debugger
   if(event.target.value === "Lock")
   {
    setLockStatus("Lock")
   setLock(true)
   }
   else{
    setLockStatus("Unlock")
    setLock(false)
   }
  };
  
  const handleClickLockuser = (data) => {
    setOpenLockuser(true)
    if(data.islockedd === true){
      setLockStatus("Lock")
    }
    else{
      setLockStatus("Unlock")
    }
   
    setUserId(data);

  };
  const Lockusersave = (event) => {
      let data = { UserName : uersId.username , IsLocked : Lock };
        dispatch({ type: LOADING, payload: true });
        event.preventDefault();
          const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User/LoginUnLocked`;
          dispatch({ type: LOADING, payload: true });
          postRequest(url, data)
              .then((res) => {
                  console.log("res", res);
                  if (res.status == 200) {
                      ToastSuccess("Saved Successfully");
                      dispatch({ type: LOADING, payload: false });
                     // history.push("/dashboard/admin");
                     //setLockStatus(Lockstatus);
                     setOpenLockuser(false)
                     getAllUser();
                  }
                  else {
                      ToastError("unsucessfull");
                      dispatch({ type: LOADING, payload: false });
                  }
              })
              .catch((error) => {
                  ToastError(error.response.data.message);
                  dispatch({ type: LOADING, payload: false });
              });
  }
  const handleClosePasswordForm = () => {
    setOpenPassword(false);
    setPassword("");
  };
  const handleCloselockuserform = () => {
    setOpenLockuser(false);
    setLockStatus("");
  };
  const passwordsave = (event) => {
    ////
    var pass = passwordObj.password;
    if (pass && pass !== null && pass != undefined && pass.length >= 8) {
      ////
      dispatch({ type: LOADING, payload: true });
      event.preventDefault();
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Account/UpdateAdminPassword/${uId.username}/${passwordObj.password}`;
      dispatch({ type: LOADING, payload: true });
      getRequest(url)
        .then((res) => {
          if (res.status == 200) {
            dispatch({ type: LOADING, payload: false });
            setOpenPassword(false);
            setuId(uId.username);
            setPassword(passwordObj.password);
            ToastSuccess("Password Updated successfully");
            console.log(uId.username);
            console.log(passwordObj.password);
          } else {
            // ToastError(res.data.message);
            dispatch({ type: LOADING, payload: false });
          }
        })
        .catch((error) => {
          //console.log(error);
          dispatch({ type: LOADING, payload: false });
          ToastError(error.response.data.message);
        });
    }

    // setuId(uId.username);
    // setPassword(passwordObj.password);

    // console.log("uid",uId.uId);
    //  console.log("password",passwordObj);
    else {
      ToastError("Fill Password to Reset");
    }
  }
  const handleClickOpenForm = (data) => {
    setOpenform(true);
  };
  const handleClickClose = () => {
    setOpenform(false);
  };

  const handleChange = (event) => {
    setStatusValue(event.target.value);
  };

  const getMuiTheme = () => createTheme({

    overrides: {
      MUIDataTableHeadCell: {
        root: {
          textTransform: "none"
        }
      }
    }
  })

  const filteLogic = (val, filters) => {
    //
    let retValue = true;
    if (filters.length == 0)
      retValue = false;
    filters.forEach((filt) => {
      if (val?.indexOf(filt) > -1)
        retValue = false;
    })

    return retValue;


  }

  const adminPanelchanges1 = [
    {
      name: "userName",
      label: "UserName",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "modifiedBy",
      label: "modifiedBy",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "modifiedDate",
      label: "modifiedDate",
      options: {
        filter: true,
        sort: true,
      }
    }, {
      name: "changes",
      label: "changes",
      options: {
        filter: true,
        sort: true,
        filterType: 'custom',
        filterOptions: {
          logic: filteLogic,
          display: (filterList, onChange, index, column) => {
            const optionValues = changesParamFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Changes
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }
      }
    }]

  const option1 = {
    customToolbarSelect: () => {
      <>
        onRowsDelete: true,
      </>
    },
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    downloadOptions: {
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true
      }
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      ////
      let isAdminPanelList = [];

      rowsSelected.forEach((d) => {
        isAdminPanelList.push(adminPanelchanges[d]);
      })
      console.log("isAdminPanelList", isAdminPanelList);
      setSelectedAdminiPanelChanges(isAdminPanelList);
    },
    onDownload: (buildHead, buildBody, columns, gridData) => {
      var myData = [];
      var newKeys = Object.keys(adminPanelchanges[0]);
      var idx = 0;
      var columnsExport = [];
      var columnsExport1 = [];
      columnsExport.push("");
      columns.forEach((cl) => {
        //if(cl.label!=="Actions")
        columnsExport.push(cl.label);

      })
      // newKeys.forEach((k) => {
      //   columnsExport.push(k);
      // });
      columnsExport.push("\n");
      let i = 0;

      //console.log(item);
      selectedadminPanelchanges.length > 0 ?
        (
          selectedadminPanelchanges.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.userName && dfdt[1] == item.modifiedBy)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {

              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;

              itemData.changes = itemData.changes.replace(/[\n,]/g, "");
              itemData.modifiedDate = itemData.modifiedDate ? itemData.modifiedDate : "";
              //itemData.lastLogin = itemData.lastLogin ? itemData.lastLogin : "";

              let objAdminchanges = {
                UserName: itemData.userName,
                ModifiedBy: itemData.modifiedBy,
                ModifiedDate: itemData.modifiedDate,
                Changes: itemData.changes,
              }
              let data = [];
              data.push(...Object.values({ ...objAdminchanges }));
              data.push("\n");
              dataItem.push(data);
              // });
              myData.push(...dataItem);
              // console.log("myData",myData)
            }
          })
        ) : (
          adminPanelchanges.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.userName && dfdt[1] == item.modifiedBy)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {

              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;

              itemData.changes = itemData.changes.replace(/[\n,]/g, "");
              itemData.modifiedDate = itemData.modifiedDate ? itemData.modifiedDate : "";
              //itemData.lastLogin = itemData.lastLogin ? itemData.lastLogin : "";

              let objAdminchanges = {
                UserName: itemData.userName,
                ModifiedBy: itemData.modifiedBy,
                ModifiedDate: itemData.modifiedDate,
                Changes: itemData.changes,
              }
              let data = [];
              data.push(...Object.values({ ...objAdminchanges }));
              data.push("\n");
              dataItem.push(data);
              // });
              myData.push(...dataItem);
              // console.log("myData",myData)
            }
          })
        )

      buildHead = () => {
        console.log(columnsExport);
        return columnsExport;
      }
      buildBody = () => {
        // console.log(myData);
        return myData;
      }
      return buildHead() + buildBody();
    }
  }

  const filtLogic = (val, filters) => {
    let retValue = true;
    if (val) {
      if (filters.length == 0)
        retValue = false;
      filters.forEach((filt) => {
        if (val.indexOf(filt) > -1)
          retValue = false;
      })
    }
    return retValue;
  }

  const columns = [
    {
      name: "firstName",
      label: "First Name",
      options: {
        filter: true,
        sort: true,

      }
    },
    {
      name: "lastName",
      label: "Last Name",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "isBlackListed",
      label: "Blacklisted",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // //
          if (value === "Yes") {
            return <><span style={{ color: "#fb5124", fontWeight: 'bold' }}>Yes</span> </>
          } else {
            return <><span style={{ color: "#000000", fontWeight: 'bold' }}>No</span></>
          }
        }
      }
    },
    {
      name: "customername",
      label: "Customer Name",
      options: {
        filter: true,
        sort: true,
        display: true,
        filterType: 'custom',
        filterOptions: {
          logic: filtLogic,
          display: (filterList, onChange, index, column) => {
            const optionValues = customernameFilter;
            return (
              <FormControl variant="filled" >
                <InputLabel htmlFor='select-multiple-chip'>
                  Customer Name
                </InputLabel>
                <Select
                  multiple
                  value={filterList[index]}
                  renderValue={selected => selected.join(', ')}
                  onChange={event => {
                    filterList[index] = event.target.value;
                    onChange(filterList[index], index, column);
                  }}
                >
                  {optionValues.map(item => (
                    <MenuItem key={item} value={item}>
                      <Checkbox
                        color='primary'
                        checked={filterList[index].indexOf(item) > -1}
                      />
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            );
          }
        }
      }
    },
    {
      name: "userType",
      label: "Access Role",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "role",
      label: "Role",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "createddate",
      label: "Date Created",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "lastLogin",
      label: "Last Login",
      options: {
        filter: true,
        sort: true,
      }
    },
    {
      name: "status",
      label: "	Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (Value, tableMeta) => {
          ////
          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            return <button className={classes.link1} onClick={() => { handleClickOpen(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index], "status") }}>{Value} </button> /*0 is active and no*/
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            return <button className={classes.link3} /*onClick={() => { handleClickOpen(registeredUsers[tableMeta.rowIndex], 1) }}*/>{Value} </button>/*1 is Inactive and yes*/
          }
          // if (registeredUsers[tableMeta.rowIndex].isBlackListed == 0 ) {
          //   return <button className={classes.link1} onClick={() => { handleClickOpen(registeredUsers[tableMeta.rowIndex], "status") }}>{Value} </button> /*0 is active and no*/
          // }
          // else if (registeredUsers[tableMeta.rowIndex].isBlackListed == 1) {
          //   return <button className={classes.link3} /*onClick={() => { handleClickOpen(registeredUsers[tableMeta.rowIndex], 1) }}*/>{Value} </button>/*1 is Inactive and yes*/
          // }

        }
      }
    },
    {
      name: "Edit",
      label: "	Actions",
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            return <button className={classes.link} onClick={() => { onEditUserDetails(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index]) }}>Edit </button>
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            return <button className={classes.link2} /*onClick={() => { onEditUserDetails(registeredUsers[tableMeta.rowIndex], 1) }}*/>Edit </button>
          }
        }
      }
    },
    {
      name: "bmAccess",
      label: "	BM Access",
      options: {
        filter: true,
        sort: true,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          //
          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            if (Value == "" || Value == null) {
              return <p  >No Access </p>
            } else {
              return <button className={classes.link} onClick={() => { handleClickOpen(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index], "BMaccess") }}>{Value} </button>
            }
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            if (Value == "" || Value == null) {
              return <p  >No Access </p>
            } else {
              return <button className={classes.link2} /*onClick={() => { handleClickOpen(registeredUsers[tableMeta.rowIndex], 1) }}*/>{Value} </button>
            }
          }
        }
      }
    },
    {
      name: "changes",
      label: "Changes",
      options: {
        filter: false,
        download: false,
        customBodyRender: (Value, tableMeta) => {

          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            return <button className={classes.link} onClick={() => { adminpanelchanges(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index]) }}><FindReplaceIcon /></button>
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            return <button className={classes.link2} /*onClick={() => { adminpanelchanges(registeredUsers[tableMeta.rowIndex]) }}*/><FindReplaceIcon /></button>
          }
        }
      }
    },
    {
      name: "password",
      label: "Reset Password",
      options: {
        filter: false,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          // //
          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            return <button className={classes.link} onClick={() => { handleClickOpenPasswordForm(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index]) }}><PasswordIcon /></button>
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            return <button className={classes.link2} /*onClick={() => { adminpanelchanges(registeredUsers[tableMeta.rowIndex]) }}*/><PasswordIcon /></button>
          }
        }
      }
    },
    {
      name: "islockedd",
      label: "Account Status",
      options: {
        filter: false,
        download: false,
        customBodyRender: (Value, tableMeta) => {
          debugger
          if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "No") {
            return <button className={classes.link} onClick={() => {handleClickLockuser(registeredUsers[tableMeta.currentTableData[tableMeta.rowIndex].index]) }}>
              {Value == true ?(
                <>
                <LockIcon/>
                
                </>
              ):(
                <>
                <KeyIcon/>
                </>

              )}
              
              </button>
          } else if (tableMeta.currentTableData[tableMeta.rowIndex].data[3] === "Yes") {
            return <button className={classes.link2} /*onClick={() => { adminpanelchanges(registeredUsers[tableMeta.rowIndex]) }}*/><PasswordIcon /></button>
          }
          
        }
      }
    },
  ];

  const options = {
    customToolbarSelect: () => {
      <>
        onRowsDelete: true,
      </>
    },
    selectToolbarPlacement: "above",
    selectableRows: "multiple",
    responsive: 'standard',
    filterType: 'multiselect',
    rowsPerPageOptions: [10, 15, 50, 100],
    textLabels: 'label',
    rowsSelected: selectedRows,
    downloadOptions: {
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true
      }
    },
    onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
      ////
      let isUserList = [];

      rowsSelected.forEach((d) => {
        isUserList.push(registeredUsers[d]);
      })
      //console.log("isUserList", isUserList);
      setSelectedRegisteredUsers(isUserList);
      setSelectedRows([...rowsSelected])
    },
    onDownload: (buildHead, buildBody, columns, gridData) => {
      var myData = [];
      var newKeys = Object.keys(registeredUsers[0]);
      var idx = 0;
      var columnsExport = [];
      var columnsExport1 = [];
      columnsExport.push("");
      columns.forEach((cl) => {
        if (cl.label !== "\tActions" && cl.label !== "\tBM Access" && cl.label !== "Changes" && cl.label !== "Reset Password")
          columnsExport.push(cl.label);

      })
      // newKeys.forEach((k) => {
      //   columnsExport.push(k);
      // });
      columnsExport.push("\n");
      let i = 0;

      //console.log(item);
      selectedregisteredUsers.length > 0 ?
        (
          selectedregisteredUsers.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              console.log("gridData", gridData);
              let dfdt = df.data;
              if (dfdt[0] == item.firstName && dfdt[1] == item.lastName)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {

              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;

              itemData.customername = itemData.customername.replace(/,/g, "");
              itemData.createddate = itemData.createddate ? itemData.createddate : "";
              itemData.lastLogin = itemData.lastLogin ? itemData.lastLogin : "";
              itemData.isBlackListed = itemData.isBlackListed == 0 ? "No" : "Yes";

              let objRegistedredUsers = {
                FirstName: itemData.firstName,
                LastName: itemData.lastName,
                Email: itemData.email,
                Blacklisted: itemData.isBlackListed,
                CustomerName: itemData.customername,
                AccessRole: itemData.userType,
                Role: itemData.role,
                DataCreated: itemData.createddate,
                LastLogin: itemData.lastLogin,
                Status: itemData.status
              }
              let data = [];
              data.push(...Object.values({ ...objRegistedredUsers }));
              data.push("\n");
              dataItem.push(data);
              // });
              myData.push(...dataItem);
              // console.log("myData",myData)
            }
          })
        ) : (
          registeredUsers.forEach((item) => {
            let visibleRows = gridData.filter((df) => {
              let dfdt = df.data;
              if (dfdt[0] == item.firstName && dfdt[1] == item.lastName)
                return true;
              else
                return false;

            });
            if (visibleRows.length > 0) {

              let itemData = { ...item };
              let dataItem = []
              if (i == 0)
                dataItem.push("");
              i++;

              itemData.customername = itemData.customername.replace(/,/g, "");
              itemData.createddate = itemData.createddate ? itemData.createddate : "";
              itemData.lastLogin = itemData.lastLogin ? itemData.lastLogin : "";

              let objRegistedredUsers = {
                FirstName: itemData.firstName,
                LastName: itemData.lastName,
                Email: itemData.email,
                Blacklisted: itemData.isBlackListed,
                CustomerName: itemData.customername,
                AccessRole: itemData.userType,
                Role: itemData.role,
                DataCreated: itemData.createddate,
                LastLogin: itemData.lastLogin,
                Status: itemData.status
              }
              let data = [];
              data.push(...Object.values({ ...objRegistedredUsers }));
              data.push("\n");
              dataItem.push(data);
              // });
              myData.push(...dataItem);
              // console.log("myData",myData)
            }
          })
        )
      buildHead = () => {
        console.log(columnsExport);
        return columnsExport;
      }
      buildBody = () => {
        // console.log(myData);
        return myData;
      }
      return buildHead() + buildBody();
    }
  }
  // const getMuiTheme = () =>
  //   createTheme({
  //     overrides: {
  //       MUIDataTable: {
  //         root: {
  //           backgroundColor: '#AAF',
  //         },
  //         paper: {
  //           boxShadow: 'none',
  //         },
  //       },
  //       MuiToolbar: {
  //         root: {
  //           backgroundColor: '#f00',
  //         },
  //       },
  //       MuiTableHeader: {
  //         head: {
  //           backgroundColor: 'purple',
  //         },
  //       },
  //       MUIDataTableSelectCell: {
  //         headerCell: {
  //           backgroundColor: 'blue',
  //         },
  //       },
  //       MuiTableFooter: {
  //         root: {
  //           '& .MuiToolbar-root': {
  //             backgroundColor: 'white',
  //           },
  //         },
  //       },
  //     },
  //   });


  const getData = () => {

    return registeredUsers.map((row) => {
      let modified = {
        ...row, ...{
          isBlackListed: row.isBlackListed === 0 ? "No" : "Yes"
        }
      }
      return modified
    });
  };

  const handleClose1 = () => {
    setOpen(false);
  };
  const adminpanelchanges = (value) => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User/AdminPanelChanges/${value.email}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          dispatch({ type: LOADING, payload: false });
          let chan = [];
          res.data.forEach((d) => {
            d.modifiedDate = moment(d.modifiedDate).format('DD/MM/YYYY');
            d?.changes !== null ? chan.push(...d?.changes.split(",")) : chan.push(...[]);
          })
          setChangesParamFilter([...new Set(chan)]);
          setOpen(true);
          setAdminiPanelChanges(res.data)

        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
      });
  }
  const handleClickOpen = (row, value) => {
    debugger

    if ((row.status == "Active" || row.status == "Pending" || row.status == "Inactive") && value == "status") {
      if (getCookie('userRole') == 'ClientAdmin') {
        console.log('checking', getCookie('userRole'))
        ToastError("Kindly contact VPS admin to Active or Inactive the user. ");
      } else {
        setOpenStatusAlert(true);
        setStatusValue(row.status)
        setActiveUser(row);
      }


    } else if (value == "BMaccess") {
      setOpenAlert(true);
    }
    setMode(value);
    setBmaccessstatus({ ...row });

  }

  const onChangeSubmit = (value, field) => {
    //
    //console.log(value);
    setReason(value)
  }
  const onAlertSubmit = (status) => {
    debugger

    if (mode === "status") {
      if (status == "Active") {
        onUpdateUserStatus({ ...activeUser, status: "Approved" });
      } else if (status == "Inactive") {
        onUpdateUserStatus({ ...activeUser, status: "Inactive" });
      }
      setOpenStatusAlert(false);
      setActiveUser({});
    } else if (mode === "BMaccess") {
      let BM = "";
      if (status == "approval") {
        BM = "Approved";
      } else if (status == "reject") {

        BM = "Denied";
      }
      if (Reason !== "" && Reason !== undefined) {
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
          `User/UpdateBMAccess/${BmsccessStatus.uId}/${BM}/${Reason}`;
        getRequest(url)
          .then((res) => {
            ////
            if (res) {
              getAllUser();
              getallbunkermasterhistory();
              setReason('');
            } else {
              getAllUser();
            }

          }).catch((err) => {
            //console.log(err);
          })
        // setOpenAlert(false);
      } else {
        ToastError("Fill the reason");
      }

    } else if (status == "cancel") {
      setOpenAlert(false);
      setOpenStatusAlert(false);
    }

  }
  const getallbunkermasterhistory = () => {
    //
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `User/BMaccesshistory/${BmsccessStatus.email}`;
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.data) {
          dispatch({ type: LOADING, payload: false });
          res.data.forEach((d) => {
            d.createdDate = moment(d.createdDate).format('DD/MM/YYYY');
          })
          //console.log(res.data);
          setBunkermasterhistory(res.data)

        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
      });
  }

  const handleClose = () => {
    setOpenAlert(false);
    setActiveUser({});
    setBunkermasterhistory([]);
  };
  const onUpdateUserStatus = (obj) => {
    //
    // let status = "";
    // if(obj.status=="Registered") status = "Approved";
    // if(obj.status=="Active") status = "Inactive";
    // if(obj.status=="Inactive") status = "Registered";
    ////console.log(obj, 'test');
    ////console.log(obj.regId);
    if (obj.regId == null) {
      obj.regId = 0;
    }
    ////console.log(obj.regId);

    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `UserRegistration/${obj.regId}/${obj.uId}/${obj.status}`;
    dispatch({ type: LOADING, payload: true });
    putRequest(url)
      .then((res) => {
        ////console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          getAllUser();
          ToastSuccess(res.data.message);
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        ////console.log(error.response);
        if (error.response.data.title) {
          ToastError(error.response.data.title);
        } else if (error.response.data.title) {
          ToastError(error.response.data.message);
        } else {
          ToastError("try again after some time or contact your help desk");
        }
      });
  }

  const onEditUserDetails = (obj) => {

    history.push("/dashboard/admin/edit-user/" + obj.username);


  }

  const getCustomername = () => {
    const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + "Customer";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          let totalArray = [];
          res.data.map((item) => {
            if (item.customerName || item.customerkeys) {
              totalArray.push(item.customerName);
            }
          });
          setCustomernameFilter(totalArray = ([...new Set(totalArray)]));
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }
  // const getUserid=()=>{
  //   const url =
  //   process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
  //   `UserRegistration/registeredusers`;

  //   dispatch({ type: LOADING, payload: true });
  // getRequest(url)
  //   .then((res) => {
  //     if (res.status == 200) {
  //       getAllUser()
  //     } else {
  //       dispatch({ type: LOADING, payload: false });
  //       ToastError(res.data.message);
  //     }
  //   })
  //   .catch((error) => {
  //     ToastError(error.response.data.message);
  //     dispatch({ type: LOADING, payload: false });
  //   });
  // }
  // useEffect(() => {
  // getUserid();

  // }, []);

  const getAllUser = () => {
    //
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      "UserRegistration/registeredusers";
    dispatch({ type: LOADING, payload: true });
    getRequest(url)
      .then((res) => {
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          res.data.forEach((d) => {
            if (d.lastLogin) {
              d.lastLogin = moment(d.lastLogin).format('DD/MM/YYYY');
            }
            if (d.createddate) {
              d.createddate = moment(d.createddate).format('DD/MM/YYYY');
            }
          })
          setSearchText("");
          setRegisteredUsers(res.data);
          setLoadedRegisteredUsers(res.data);
          setCustomernameFilter(getCustomername);
        } else {
          dispatch({ type: LOADING, payload: false });
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        ToastError(error.response.data.message);
        dispatch({ type: LOADING, payload: false });
      });
  }

  useEffect(() => {
    getAllUser();

  }, []);

  const matchRuleShort = (str, rule) => {
    var escapeRegex = (str) => str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
    //const lowerCased = str.toLowerCase();
    return new RegExp("^" + rule.split("*").map(escapeRegex).join(".*") + "$", "i").test(str);
  }
  const filterGrid = () => {
    ;
    ////console.log("loadedRegisteredUsers.....",loadedRegisteredUsers); 
    ////console.log("searchedRegisteredUsers......", registeredUsers);
    //const rgUser = registeredUsers.filter(() => { return true; });
    const rgUser = loadedRegisteredUsers.filter(() => { return true; });

    setRegisteredUsers(rgUser.filter((item) => {
      return matchRuleShort(item.firstName, "*" + searchText + "*") || matchRuleShort(item.lastName, "*" + searchText + "*") || matchRuleShort(item.name, "*" + searchText + "*") || matchRuleShort(item.email, "*" + searchText + "*")
    }));

  }

  //////console.log(registeredUsers);
  return (
    <div>
      <Dialog
        fullWidth={fullWidth}
        //maxWidth={maxWidth}
        maxWidth="xl"
        fullScreen={true}
        open={open}
        onClose={handleClose1}
      >
        <DialogActions>
          <Button onClick={handleClose1}><CancelIcon /></Button>
        </DialogActions>

        <DialogContent>
          <Box display="block" mb={3} my={3} component="div" className="reportstablehead">
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                className={classes.tableBody}
                title={"Admin panel changes"}
                data={adminPanelchanges}
                columns={adminPanelchanges1}
                options={option1}
              />

            </ThemeProvider>
          </Box>
        </DialogContent>

      </Dialog>
      <Box component="main" mx={3} mt={3}>
        <Box className={classes.boxLayout}>
          <Box
            display="dlock"
            bgcolor="#1a1a31"
            className={classes.breadcrumbBox}
          >
            <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpenForm} />} />
          </Box>
          <div>
            <Box component="div" className="pos_relative">


              {/*<Button onChange={handleClickOpen}/>*/}

              <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Admin Panel</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Admin Panel</p><br />
                    <img className="maxwidth100" src="/assets/images/Admin_panel_help_section1.jpg"></img><br /><br />
                    <p>
                      <li>Click search button <img src={searchicon} alt="" width="40px" height="40px" /> to search the entire table</li><br />
                      <li>Click download button <img src={downloadicon} alt="" width="40px" height="40px" /> to download the table in excel</li><br />
                      <li>Click print button <img src={printicon} alt="" width="40px" height="40px" /> to open the print options</li><br />
                      <li>Click view column button <img src={viewcolumnicon} alt="" width="40px" height="40px" /> to display column name fields</li><br />
                      <li>Click filter button <img src={filtericon} alt="" width="40px" height="40px" /> to open the filter options</li><br />
                    </p>
                    <img className="maxwidth100" src="/assets/images/Admin_panel_help_section2.jpg"></img><br /><br />
                    <p>
                      <li>Status column will display whether the customer status is Active or Inactive</li><br />
                      <li>Click the edit will take the admin to edit mode where admin can edit the details manually</li><br />
                      <li>Click the changes icon will display(whatever the admin edited) in the changes</li><br />
                      <li>Select the <img src={Checkimage} alt="" width="30px" height="30px" /> and click <DeleteIcon /> on the top of the grid to delete particular row</li>
                    </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Box>
          </div>

          <Box className="Dialog">
            <Dialog open={openPassword} onClose={handleClosePasswordForm}>
              <DialogTitle style={{ color: "#ff4717" }}>Reset Your Password</DialogTitle>
              <DialogContent>
                <Box className={classes.Box}>
                  <Grid container spacing={2}>
                    <Grid item xs={7} className={classes.text1}>
                      <TextField
                        autoFocus
                        fullWidth
                        margin="dense"
                        name="username"
                        type="text"
                        value={uId.username}
                        label="Username"
                        variant="standard"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={7} className={classes.password}>
                      <TextField
                        autoFocus
                        fullWidth
                        margin="normal"
                        name="password"
                        type="password"
                        label="Password"
                        variant="standard"
                        value={passwordObj.password}
                        onChange={onChangeText}
                      />
                    </Grid>
                    <Grid style={{ paddingTop: "55px", paddingLeft: "25px" }}>
                      <Typography>
                        <span className="redstar1">*</span>
                        Password must have 8 letters.
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={passwordsave}>Save</Button>
                <Button onClick={handleClosePasswordForm}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </Box>
          <Box className="Dialog">
            <Dialog open={openLockuser} onClose={handleCloselockuserform}>
              <DialogTitle style={{ color: "#ff4717" }}>Do You Want to Lock/Unlock the User</DialogTitle>
              <DialogContent>
                <Box className={classes.Box}>
                  <Grid container spacing={2}>
                    <Grid item xs={7} className={classes.text1}>
                      <TextField
                        autoFocus
                        fullWidth
                        margin="dense"
                        name="username"
                        type="text"
                        value={uersId.username}
                        label="Username"
                        variant="standard"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <AccountCircle />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Box display="block" pt={0.5}>
                        <RadioGroup
                          aria-label="Status"
                          name="isActive"
                          value={Lockstatus}
                          onChange={lockuseronChangeText}
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            className={classes.radioInput}
                          >
                            <FormControlLabel
                              value="Lock"
                              control={<Radio />}
                              label="Lock"
                            />
                            <FormControlLabel
                              value="Unlock"
                              control={<Radio />}
                              label="Unlock"
                            />
                          </Box>
                        </RadioGroup>
                      </Box>
                  </Grid>
                </Box>
              </DialogContent>
              <DialogActions>
                <Button onClick={Lockusersave}>Save</Button>
                <Button onClick={handleCloselockuserform}>Cancel</Button>
              </DialogActions>
            </Dialog>
          </Box>
          <Dialog
            open={openStatusAlert}
          >
            <DialogTitle style={{ color: "#ffffff" }} >
              {"Are you sure you want to change the status?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">

                <Box component="label" pt={2} >
                  Status
                </Box>
                <Box display="block" pt={0.5}>
                  <RadioGroup
                    aria-label="Status"
                    name="isActive"
                    value={statusValue}
                    onChange={handleChange}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      className={classes.radioInput}
                    >
                      <FormControlLabel
                        value="Active"
                        control={<Radio />}
                        label="Active"
                      />
                      <FormControlLabel
                        value="Inactive"
                        control={<Radio />}
                        label="Inactive"
                      />
                    </Box>
                  </RadioGroup>
                </Box>

              </DialogContentText>
            </DialogContent>
            <Box component="div" display="flex" py={1} pl={1} justifyContent="center"   >
              <Button onClick={() => { onAlertSubmit('cancel') }} className={classes.btnStyle5} color="primary">
                Cancel
              </Button>
              <Button onClick={() => { onAlertSubmit(statusValue) }} className={classes.btnStyle4} color="primary" autoFocus>
                Save
              </Button>
            </Box>
          </Dialog>


          <Box
            display="flex"
            className={classesCommonCss.justifyContentBetween}
            alignItems="center"
            px={3}
            pt={3}
            pb={5}
          >
            {/* <Box width={0.8}>
              <Box display="flex" alignItems="center">
                <Box component="span" fontSize="16px" style={{ verticalAlign: applyMiddleware, marginTop: 5 }}>
                  {"Search"}
                </Box>
                <Box component="span" ml={2} width="260px">
                  <TextField
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    name="search"
                    className={classes.txtInput}
                    placeholder="Type"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />

                </Box>
                <Box component="span" ml={2} width="auto">
                  <Button
                    className={classes.btnStyle1}
                    onClick={(e) => filterGrid()}
                  >Search</Button>
                </Box>
                <Box component="span" ml={3} width="260px" style={{ marginLeft: 10 }} >
                  <Button
                    className={classes.btnStyle1}
                    onClick={() => getAllUser()}
                  >Clear</Button>
                </Box>
              </Box>
            </Box> */}
            <Box component="span" width="310px"    >
              <Button
                className={classes.btnStyle2}

                onClick={() => {
                  history.push("/dashboard/Blacklistdomain");
                }}
              >
                BlackListed Domains
              </Button>
            </Box>
            <Box component="span" width="260px">
              <Button
                className={classes.btnStyle2}

                onClick={() => {
                  history.push("/dashboard/Customerdomain");
                }}
              >
                Customer Domain
              </Button>
            </Box>
            <Box component="span" width="260px">
              <Button
                className={classes.btnStyle2}

                onClick={() => {
                  //debugger
                  history.push("/dashboard/Customersetting");
                }}
              >
                Customer Setting
              </Button>
            </Box>
            <Box component="span" width="260px"   >
              <Button
                className={classes.btnStyle2}

                onClick={() => {
                  history.push("/dashboard/admin/add-user");
                }}
              >
                Add User
              </Button>
            </Box>
          </Box>
          <Box className="reportstablehead" pb={5} px={1}>
            {/* <TableContainer component={Paper} className={classes.tableLayout}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>First Name</StyledTableCell>

                    <StyledTableCell>Last Name</StyledTableCell>
                    <StyledTableCell>Email</StyledTableCell>
                    <StyledTableCell>Blacklisted</StyledTableCell>
                    <StyledTableCell>Access Role</StyledTableCell>
                    <StyledTableCell>Role</StyledTableCell>
                    <StyledTableCell>Date Created</StyledTableCell>
                    <StyledTableCell>Last Login</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Actions</StyledTableCell>
                    <StyledTableCell>BM Access</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {registeredUsers.length
                    ? registeredUsers.map((row) => (
                      <Row key={row.username} getAllUser={getAllUser} updateUserStatus={onUpdateUserStatus} editUserDetails={onEditUserDetails} row={row} />
                    ))
                    : ""}
                </TableBody>
              </Table>
            </TableContainer> */}
            <ThemeProvider theme={getMuiTheme()}>
              <MUIDataTable
                title={"User List"}
                data={getData()}
                //data={registeredUsers}
                className={classes.tableBody}
                columns={columns}
                options={options}
              />
              <Confirmation open={openAlert} onClose={handleClose} onHandleSubmit={onAlertSubmit} BMhistorydata={Bunkermasterhistory} onChange={onChangeSubmit} clickMode={mode} />

            </ThemeProvider>
          </Box>
        </Box>
      </Box>
    </div>
  );
}